import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { RowData } from "../views/YouTubeScorecard/Interfaces/interfaces";
import {
  filterYouTubeScorecardRows,
  getMyIssuesRows,
} from "./filterYouTubeScorecardRows";

export const useYouTubeScorecardFilters = (rows: RowData[]) => {
  const [filters, setFilters] = useState<any>({});
  const [filteredRows, setFilteredRows] = useState<RowData[]>([]);
  const [myIssuesRows, setMyIssuesRows] = useState<RowData[]>([]);
  const [myIssuesOnly, setMyIssuesOnly] = useState<boolean>(false);

  const user = useSelector((state: any) => state.googleAuth.user);
  const loggedInUserEmail = user?.email;

  useEffect(() => {
    setFilteredRows(rows);
  }, [rows]);

  // useEffect to determine myIssuesRows
  useEffect(() => {
    if (loggedInUserEmail) {
      const filteredRows = getMyIssuesRows(rows, loggedInUserEmail);
      setMyIssuesRows(filteredRows);
      if (filteredRows.length > 0) {
        setMyIssuesOnly(true);
      } else {
        setMyIssuesOnly(false);
      }
    } else {
      setMyIssuesRows([]);
      setMyIssuesOnly(false);
    }
  }, [rows, loggedInUserEmail]);

  const handleFilterChange = useCallback((newFilters: any) => {
    setMyIssuesOnly(newFilters.myIssuesOnly);
    setFilters(newFilters);
  }, []);

  const applyFilters = useCallback(
    (filters: any, filterOptions: any) => {
      const filteredRows = filterYouTubeScorecardRows({
        rows,
        filters,
        filterOptions,
        myIssuesOnly,
        myIssuesRows,
        loggedInUserEmail,
      });
      setFilteredRows(filteredRows);
    },
    [loggedInUserEmail, rows, myIssuesRows, myIssuesOnly]
  );

  return {
    filters,
    filteredRows,
    myIssuesRows,
    myIssuesOnly,
    handleFilterChange,
    applyFilters,
  };
};
